$(document).ready(function(){
    $(".additional-colors .color--add").each(function(){
      var selected_color = $(this).find("a.siblings__link.siblings__link--current").attr("selected-color");
      $(this).find(".header span").text(selected_color);
    })    
    $(".eco-option span.checker").on("click",function(){
      console.log("clicked");
      var id = $(this).siblings("input[type='checkbox']").val();      
      if($(this).siblings("input[type='checkbox']").is(":checked"))
      {
        $(this).siblings("input[type='checkbox']").prop("checked",false);        
        $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        async:true,
        data: {
          quantity: 0,
          id: id
        },
          dataType: 'json', 
         success: function (data) {            
           console.log(data)
           $.ajax({
             type:"POST",
             url:"/cart.js",
             dataType:"json",
             success : function(cartd)               
               {
                 if ( cartd.items < 1 )
                 {
                    $.ajax({
                     type:"GET",
                     url:"/",
                     dataType:"html",
                     success : function(response){
                       location.reload();
                       
                     }
                   })
                 }
                 else
                 {
                   console.log(cartd)
                   $.ajax({
                   type:"GET",
                   url:"/",
                   dataType:"html",
                   success : function(response){                  
                     var data = $(response).filter("#cart-drawer ").find(".drawer__items").html();
                     console.log(data)
                     $("#cart-drawer").find(".drawer__items").html(data);
                     $("#cart-drawer").find(".cart__item").addClass("cart__item--no-border no--remove--data is-animated");
                     // var ship = $(response).filter(".cart-drawer ").find(".cart-drawer__message").html();
                     // console.log(ship)
                     // $(".cart-drawer ").find(".cart-drawer__message").html(ship);
                     //$(".cart-drawer ").find(".cart-drawer__message").addClass("is-animated");
                     var price = $(response).filter("#cart-drawer ").find(".cart__total__price").html();
                     $("#cart-drawer").find("span.cart__total__price").html(price);
                       console.log(typeof(cartd.items_subtotal_price))
                      cart.freeShippingMessageHandle(cartd.items_subtotal_price);
                      cart.updateProgress(cartd.items_subtotal_price);                     
                      cart.cartEvents();
                      cart.init();
                      cart.toggleErrorMessage();
                      cart.enableCartButtons();    
                     
               }
             })
                 }                 
               }             
           })
         }
       });
      }
      else
      {
       $(this).siblings("input[type='checkbox']").prop("checked",true);
       $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async:true, 
        data: {
          quantity: 1,
          id: id
        },
          dataType: 'json', 
         success: function (data) { 
           $.ajax({
             type:"POST",
             url:"/cart.js",
             dataType:"json",
             success : function(cartd)
               
               {
                 console.log(cartd)
                 $.ajax({
                 type:"GET",
                 url:"/",
                 dataType:"html",
                 success : function(response){
                   
                   var data = $(response).filter("#cart-drawer ").find(".drawer__items").html();
                     console.log(data)
                     $("#cart-drawer").find(".drawer__items").html(data);
                     $("#cart-drawer").find(".cart__item").addClass("cart__item--no-border no--remove--data is-animated");
                     // var ship = $(response).filter(".cart-drawer ").find(".cart-drawer__message").html();
                     // console.log(ship)
                     // $(".cart-drawer ").find(".cart-drawer__message").html(ship);
                     //$(".cart-drawer ").find(".cart-drawer__message").addClass("is-animated");
                      var price = $(response).filter("#cart-drawer ").find(".cart__total__price").html();
                     $("#cart-drawer").find("span.cart__total__price").html(price);
                   console.log(typeof(cartd.items_subtotal_price))
                    cart.freeShippingMessageHandle(cartd.items_subtotal_price);
                    cart.updateProgress(cartd.items_subtotal_price);
                    cart.cartEvents();
                    cart.init();
                    cart.toggleErrorMessage();
                    cart.enableCartButtons();   
                   
             }
           })
               }
             
           })      
         }
       });
      }
    });
    $(".cart__item").each(function(){
    var id = $(this).attr("pr-id");
     // console.log(id);
      $(this).addClass("no--remove--data");
      $(".eco-container").each(function(){
    var find = $(this).find("input.add-on").val();
       // console.log(find);
      if ( find == id )
      {
      $(this).find("input.add-on").prop("checked",true);
      }
    })
    })
    $(".eco-container").each(function(){
    var find = $(this).find("input.add-on").val();
     // console.log(find)

      $("tr.cart__row[data-id='"+find+"']").addClass("remove--data");
      $("tr.cart__row[data-id='"+find+"']").removeClass("no--remove--data");
    });
    $("tr.cart__row").find("input.cart__qty-input").on("change", function(e){
       e.preventDefault();
     e.stopPropagation();
    var getval = $(this).val();
      var getline = $(this).parents("tr").attr("data-cart-item-index");
      //console.log(getval);
      setTimeout(function(){ 
      var count = $("tr.cart__row.no--remove--data").length;
     // console.log(count);
      if ( count < 1 )
      {
       // console.log("empty cart");
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        dataType: 'json',
        success: function(response) {
           location.reload();
        }
      });
      }
        }, 2000);
      update_quantity(getval,getline)
      
    })
    $("a.text-link.text-link--accent").on("click", function(e){
      e.preventDefault();
      e.stopPropagation();
      var getval = 0;
      var getline = $(this).parents(".cart__row").attr("data-cart-item-index");
      update_quantity(getval,getline)
    
    })
     function update_quantity(getval,getline)
{
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=' + getval + '&line=' + getline,
    dataType: 'json',
    success: function(data) 
    {
      $("input.cart__submit.btn.btn--small-wide").val("Warenkorb neu laden");
      if(data.item_count > 0){
        $('#CartCount span').html(data.item_count);
        $("span.item--count--head").text(data.item_count);
      } else {
        $('#CartCount span').html(data.item_count) ;
        $("span.item--count--head").text(data.item_count);
      }
      $.ajax({
        type: "GET",
        url: "/cart",
        dataType: 'html',
        success: function(data) 
        {
          var minidata=$(data).find("form.cart").html(); 
                      $('form.cart').html(minidata);  
          $("tr.cart__row").each(function(){
    var id = $(this).attr("data-id");
     // console.log(id);
      $(this).addClass("no--remove--data");
      $(".eco-container").each(function(){
    var find = $(this).find("input.add-on").val();
       // console.log(find);
      if ( find == id )
      {
      $(this).find("input.add-on").prop("checked",true);
      }
    })
    })
    $(".eco-container").each(function(){
    var find = $(this).find("input.add-on").val();
     // console.log(find)
      $("tr.cart__row[data-id='"+find+"']").addClass("remove--data");
      $("tr.cart__row[data-id='"+find+"']").removeClass("no--remove--data");
    });
           $("tr.cart__row").find("input.cart__qty-input").on("change", function(e){
    
  e.preventDefault();
     e.stopPropagation();
    //console.log("cqty")
    var get = $(this).val();
    //console.log(get)
	 var getline = $(this).parents("tr").attr("data-cart-item-index");
             
    update_quantity(get,getline)

  })
           $(".eco-option span.checker").on("click",function(){
             console.log("clicked");
      var id = $(this).siblings("input[type='checkbox']").val();
      if($(this).siblings("input[type='checkbox']").is(":checked"))
      {
        $(this).siblings("input[type='checkbox']").prop("checked",false);
        
        $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        async:true,
        data: {
          quantity: 0,
          id: id
        },
          dataType: 'json', 
         success: function (data) { 
           location.reload();
         }
       });
      }
      else
      {
       $(this).siblings("input[type='checkbox']").prop("checked",true);
       $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async:true, 
        data: {
          quantity: 1,
          id: id
        },
          dataType: 'json', 
         success: function (data) { 
           location.reload();
         }
       });
      }
    });

       var count = $("tr.cart__row.no--remove--data").length;
     // console.log(count);
      if ( count < 1 )
      {
     //   console.log("empty cart");
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        dataType: 'json',
        success: function(response) {
           location.reload();
        }
      });
      }
          $("a.text-link.text-link--accent").on("click", function(e){
      e.preventDefault();
      e.stopPropagation();
      var getval = 0;
      var getline = $(this).parents(".cart__row").attr("data-cart-item-index");
      update_quantity(getval,getline)
    
    })
        }
      })
    }
  })
}
//     var item_id = '{{ p1.variants[0].id }}';
//     var check = $(".cart__row[data-id='"+item_id+"']").length;
//    // console.log(check);
//     if(check == 1)
//     {
//       $(".eco-option").find("input[type='checkbox']").prop("checked",true);
//       var count = $("#CartCount").find("span:nth-child(1)").text();
//       count = parseInt(count) - 1;
//       $("#CartCount").find("span:nth-child(1)").text(count);
//       $(".cart__remove").on("click",function(e){
//         e.preventDefault();
//        var item_check = $("tbody .cart__row").length;
//    //     console.log(item_check);
//         if(item_check <= 2)
//         {
//           setTimeout(function(){
//           $(".eco-option").trigger("click");
//           }, 500);
//         }
//         else
//         {
//           var url = $(this).find("a").attr("href");
//           window.location.href = url;
//         }
//       });
//     }
  });
